import { EnvironmentName } from "@sazka/utils/models/global-types";
import { MessageInitDto, MessageStartDto } from "../models/window-message-dto";

export namespace WorkerData {
    export let playerId: string;
    export let sessionToken: string;
    export let baseUrl: string;
    export let environment: EnvironmentName;
    export let appInsightsKey: string;

    export const setInitData = (data: MessageInitDto) => {
        baseUrl = data.baseUrl;
        environment = data.environment;
        appInsightsKey = data.appInsightsKey;
    };

    export const setStartData = (data: MessageStartDto) => {
        playerId = data.playerId;
        sessionToken = data.sessionToken;
    };
}
